import React from 'react'

import {
    AccessTime,
    Add,
    ArrowBackIos,
    ArrowDropDown,
    ArrowDropUp,
    ArrowForwardIos,
    AttachMoney,
    Cancel,
    Check,
    CheckCircle,
    CheckCircleOutline,
    CheckCircleRounded,
    Close,
    CloudUploadOutlined,
    Dashboard,
    Delete,
    DeleteOutline,
    Description,
    Edit,
    Email,
    ErrorOutlineOutlined,
    ExpandLess,
    ExpandMore,
    FiberManualRecord,
    Flag,
    FlashOn,
    HighlightOff,
    Info,
    InfoOutlined,
    ListAlt,
    Menu,
    MoreHoriz,
    MoreVert,
    PanoramaOutlined,
    Person,
    Phone,
    RemoveCircleOutline,
    ReportProblem,
    ReportProblemOutlined,
    Schedule,
    Search,
    SentimentSatisfiedOutlined,
    SystemUpdateAlt,
    Tune,
    VisibilityOutlined,
} from '@mui/icons-material'
import ActiveIcon from '../assets/icons/Active.svg'
import AssortmentIcon from '../assets/icons/Assortment.svg'
import ImageSearch from '../assets/icons/ImageSearch.svg'
import InactiveIcon from '../assets/icons/Inactive.svg'
import InventoryImportIcon from '../assets/icons/InventoryImportIcon.svg'
import LiveStatus from '../assets/icons/LiveStatus.svg'
import PercentageIcon from '../assets/images/percentage.png'
import Prioritize from '../assets/icons/Prioritize.svg'
import ProductIcon from '../assets/icons/Product.svg'
import ProductImportIcon from '../assets/icons/ProductImportIcon.svg'
import Promotions from '../assets/icons/Promotions.svg'
import PushNotifications from '../assets/icons/PushNotifications.svg'
import QATestingIcon from '../assets/icons/qatesting.svg'
import SettingsIcon from '../assets/icons/Settings.svg'
import StoreIcon from '../assets/icons/store.svg'
import StoreIcon2 from '../assets/icons/storeIcon2.svg'
import StoreOpsTools from '../assets/icons/StoreOpsTools.svg'
import SyncIcon from '../assets/icons/Sync.svg'
import TrashCanIcon from '../assets/icons/TrashCanIcon.svg'
import { strings } from '../context/LanguageContext/strings'

export const Icons = () => ({
    AccessTimeIcon: () => <AccessTime />,
    ActiveIcon: props => <img alt={strings.activeIconAltTag} src={ActiveIcon} {...props} />,
    AddIcon: () => <Add />,
    ArrowBackIosIcon: () => <ArrowBackIos />,
    ArrowDropDownIcon: () => <ArrowDropDown />,
    ArrowDropUpIcon: () => <ArrowDropUp />,
    ArrowForwardIosIcon: () => <ArrowForwardIos />,
    AssortmentIcon: props => <img alt={strings.assortmentIconAltTag} src={AssortmentIcon} {...props} />,
    AttachMoneyIcon: () => <AttachMoney />,
    CancelIcon: () => <Cancel />,
    CheckCircleIcon: () => <CheckCircle />,
    CheckCircleOutlineIcon: () => <CheckCircleOutline />,
    CheckCircleRoundedIcon: () => <CheckCircleRounded />,
    CheckIcon: () => <Check />,
    CloseIcon: () => <Close />,
    CloudUploadOutlinedIcon: () => <CloudUploadOutlined />,
    DashboardIcon: () => <Dashboard />,
    DeleteIcon: () => <Delete />,
    DeleteOutlineIcon: () => <DeleteOutline />,
    DescriptionIcon: () => <Description />,
    EditIcon: () => <Edit />,
    EmailIcon: () => <Email />,
    ErrorOutlineOutlinedIcon: color => <ErrorOutlineOutlined color={color} />,
    ExpandLessIcon: () => <ExpandLess />,
    ExpandMoreIcon: () => <ExpandMore />,
    FiberManualRecordIcon: color => <FiberManualRecord color={color} />,
    FlagIcon: color => <Flag color={color} />,
    FlashOnIcon: () => <FlashOn />,
    HighlightOffIcon: () => <HighlightOff />,
    ImageSearch: props => <img alt={strings.imageSearchAltTag} src={ImageSearch} {...props} />,
    InactiveIcon: props => <img alt={strings.activeIconAltTag} src={InactiveIcon} {...props} />,
    InfoIcon: () => <Info />,
    InfoOutlinedIcon: () => <InfoOutlined />,
    InventoryImportIcon: props => (
        <img alt={strings.inventoryImportIconAltTag} src={InventoryImportIcon} {...props} />
    ),
    ListAltIcon: () => <ListAlt />,
    LiveStatusIcon: props => <img alt={strings.liveStatusIconAltTag} src={LiveStatus} {...props} />,
    MenuIcon: () => <Menu />,
    MoreHorizIcon: () => <MoreHoriz />,
    MoreVertIcon: () => <MoreVert />,
    PanoramaOutlinedIcon: () => <PanoramaOutlined />,
    PercentageIcon: props => <img alt={strings.percentageIconAltTag} src={PercentageIcon} {...props} />,
    PersonIcon: () => <Person />,
    PhoneIcon: () => <Phone />,
    PrioritizeIcon: props => <img alt={strings.prioritizationIconAltTag} src={Prioritize} {...props} />,
    ProductIcon: props => <img alt={strings.productIconAltTag} src={ProductIcon} {...props} />,
    ProductImportIcon: props => (
        <img alt={strings.productImportIconAltTag} src={ProductImportIcon} {...props} />
    ),
    PromotionsIcon: props => <img alt={strings.promotionsIconAltTag} src={Promotions} {...props} />,
    PushNotificationsIcon: props => (
        <img alt={strings.pushNotificationsIconAltTag} src={PushNotifications} {...props} />
    ),
    QATestIcon: props => <img alt={strings.qaTestIconAltTag} src={QATestingIcon} {...props} />,
    RemoveCircleOutlineIcon: () => <RemoveCircleOutline />,
    ReportProblemIcon: () => <ReportProblem />,
    ReportProblemOutlinedIcon: color => <ReportProblemOutlined color={color} />,
    ScheduleIcon: () => <Schedule />,
    SearchIcon: () => <Search />,
    SentimentSatisfiedOutlinedIcon: () => <SentimentSatisfiedOutlined />,
    SettingsIcon: props => <img alt={strings.settingsIconAltTag} src={SettingsIcon} {...props} />,
    StoreIcon2: props => <img alt={strings.storeIcon2AltTag} src={StoreIcon2} {...props} />,
    StoreIcon: props => <img alt={strings.storeIconAltTag} src={StoreIcon} {...props} />,
    StoreOpsToolsIcon: props => <img alt={strings.storeOpsIconAltTag} src={StoreOpsTools} {...props} />,
    SyncIcon: props => <img alt={strings.SyncIcon} src={SyncIcon} {...props} />,
    SystemUpdateAltIcon: props => <SystemUpdateAlt {...props} />,
    TrashCanIcon: () => <img alt={strings.trashCanIcon} src={TrashCanIcon} />,
    TuneIcon: () => <Tune />,
    ViewIcon: () => <VisibilityOutlined />,
})
